var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.456 8.11903C3.4752 8.33088 2.59725 8.87394 1.96974 9.65693C1.34222 10.4399 1.00342 11.4151 1.01029 12.4185L1 13.279C1.00402 13.6656 1.15937 14.0352 1.43273 14.3086C1.7061 14.582 2.07571 14.7373 2.46229 14.7413L6.14114 14.7225C6.52513 14.7189 6.89238 14.5648 7.16391 14.2932C7.43544 14.0217 7.58957 13.6544 7.59314 13.2705C7.59716 12.8839 7.75251 12.5143 8.02588 12.2409C8.29924 11.9675 8.66885 11.8122 9.05543 11.8082H14.8617C15.0541 11.8068 15.2449 11.8437 15.4229 11.9167C15.601 11.9897 15.7627 12.0974 15.8988 12.2334C16.0348 12.3695 16.1425 12.5312 16.2155 12.7093C16.2885 12.8873 16.3254 13.0781 16.324 13.2705C16.3276 13.6544 16.4817 14.0217 16.7532 14.2932C17.0248 14.5648 17.392 14.7189 17.776 14.7225H21.4549C21.8413 14.718 22.2107 14.5625 22.4839 14.2892C22.7572 14.016 22.9127 13.6466 22.9171 13.2602L22.9069 12.3979C22.9136 11.3947 22.5748 10.4198 21.9472 9.6371C21.3197 8.8544 20.4418 8.31166 19.4611 8.10018C14.5033 7.15041 9.41141 7.15681 4.456 8.11903Z",
    stroke: "#E44258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndSession);
export default __webpack_public_path__ + "static/media/end-session.e8d3444e0f56535c4a83f41e563dd59e.svg";
export { ForwardRef as ReactComponent };